function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "store/store-front");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 215.12287,
  cy: 215.918479,
  r: 215
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "store/store-front",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Illustration",
  transform: "translate(95.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-19"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#B9D5E0",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Store-Illo-Copy"
}, /*#__PURE__*/React.createElement("g", {
  id: "Store-Illo"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-63.360023, 82.269030)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-26",
  fill: "#FFFFFF",
  points: "60.0839842 49.3919168 495.692869 49.3919168 495.692869 350.038367 60.0839842 350.038367"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-26",
  fill: "#009B4F",
  opacity: 0.699999988,
  points: "60.0839842 49.3919168 495.692869 49.3919168 495.692869 350.038367 60.0839842 350.038367"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-25",
  fill: "#CCCCCC",
  x: 25.7502789,
  y: 308.088874,
  width: 504.276296,
  height: 42.9494929
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-30",
  fill: "#7FD8AC",
  x: 302.565777,
  y: 92.3414097,
  width: 150.20996,
  height: 257.696957
}), /*#__PURE__*/React.createElement("path", {
  d: "M324.024343,329.563621 L431.317172,329.563621 L431.317172,114.816156 L324.024343,114.816156 L324.024343,329.563621 Z M302.565777,93.3414097 L452.775738,93.3414097 L452.775738,351.038367 L302.565777,351.038367 L302.565777,93.3414097 Z",
  id: "Rectangle-30",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "314.367989 251.254533 441.046247 251.254533 441.046247 229.779787 314.367989 229.779787"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-30",
  fill: "#7FD8AC",
  points: "103.001116 92.3414097 261.794502 92.3414097 261.794502 251.254533 103.001116 251.254533"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.459681,229.779787 L240.335937,229.779787 L240.335937,113.816156 L124.459681,113.816156 L124.459681,229.779787 Z M103.001116,92.3414097 L261.794502,92.3414097 L261.794502,251.254533 L103.001116,251.254533 L103.001116,92.3414097 Z",
  id: "Rectangle-30",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-27",
  fill: "#FFFFFF",
  points: "60.0839842 0 487.109443 0 521.443148 107.373732 25.7502789 107.373732"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-27",
  fill: "#009B4F",
  points: "60.0839842 0 487.109443 0 521.443148 107.373732 25.7502789 107.373732"
}), /*#__PURE__*/React.createElement("g", {
  id: "Simplified-v1",
  opacity: 0.699999988,
  transform: "translate(214.585658, 34.359594)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 80.3464993,
  cy: 21.4395425,
  rx: 31.8008914,
  ry: 21.4395425
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 31.8008914,
  cy: 21.4395425,
  rx: 31.8008914,
  ry: 21.4395425
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.0745454,7.58798068 C60.770071,11.3242517 63.6017829,16.1589517 63.6017829,21.4395425 C63.6017829,26.7201332 60.770071,31.5548332 56.0745454,35.2911043 C51.3774818,31.5551099 48.5456078,26.7202843 48.5456078,21.4395425 C48.5456078,16.2296202 51.3020351,11.4537342 55.8853327,7.73857334 Z",
  id: "Combined-Shape",
  fill: "#009B4F"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval-9",
  transform: "translate(0.000000, 106.456562)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-28",
  fill: "#009B4F",
  opacity: 0.400000006,
  points: "60.0839842 0.917170382 495.692869 0.917170382 495.692869 78.2262576 60.0839842 78.2262576"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-29",
  fill: "#009B4F",
  x: 25.7502789,
  y: -9.82020284,
  width: 495.692869,
  height: 15.0323225
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(25.750279, -27.000000)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 460.286236,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#00693C",
  opacity: 0.300000012,
  cx: 460.286236,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 389.472969,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 318.659702,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#00693C",
  opacity: 0.300000012,
  cx: 318.659702,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 247.846435,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 177.033168,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#00693C",
  opacity: 0.300000012,
  cx: 177.033168,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 106.219901,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#009B4F",
  cx: 35.4066335,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-9",
  fill: "#00693C",
  opacity: 0.300000012,
  cx: 35.4066335,
  cy: 35.4333316,
  rx: 35.4066335,
  ry: 35.4333316
}), /*#__PURE__*/React.createElement("line", {
  x1: 1.07292829,
  y1: 30.064645,
  x2: 494.619941,
  y2: 30.064645,
  id: "Line",
  stroke: "#46AE7A",
  strokeWidth: 2
})))))))));

var SvgStoreFront = function SvgStoreFront(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoreFront, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/store-front.5dab4445.svg";
export { ForwardRef as ReactComponent };